export default "__VITE_ASSET__B_c_0HSh__"